/**
 * Fines and repair costs, in pesewas (100 = GH₵1). Shared so the server computes the same amounts
 * from the offences a run reports, instead of trusting money totals sent by the client.
 */
export const FINES = {
  /** Crossing the stop line on red. */
  redLight: 5000,
  /** Driving through a zebra crossing while pedestrians are on it. */
  pedestrianCrossing: 3000,
  /** Running into the back of another vehicle. */
  rearEnd: 10000,
  /** Driving past a police checkpoint without stopping. */
  checkpoint: 6000,
  /** Something wrong with the papers when stopped at a checkpoint. */
  papers: 2000,
  /** A little something for the officer at a checkpoint ("dash"). Not a fine, but the server prices it the same way. */
  dashTen: 1000,
  dashTwenty: 2000,
} as const;

export type FineKind = keyof typeof FINES;

/** Repair bills by what you hit. Scrapes are cheap; big vehicles cost more. */
export const REPAIRS: Record<string, number> = {
  scrape: 1000,
  barrier: 2000,
  pragya: 2500,
  aboboyaa: 2500,
  taxi: 4000,
  saloon: 4000,
  suv: 6000,
  sprinter: 6000,
  hiace: 6000,
  truck: 8000,
};

export const DEFAULT_REPAIR = 4000;

export function repairCost(kind: string): number {
  return REPAIRS[kind] ?? DEFAULT_REPAIR;
}

/** Damage points per incident; the trotro breaks down (shift over) at 100. */
export const DAMAGE = { scrape: 5, crash: 20, breakdownAt: 100 } as const;

/** Net money from one shift. Can be negative: the driver then owes it. */
export function shiftNet(faresPesewas: number, finesPesewas: number, repairsPesewas: number, fuelPesewas = 0): number {
  return faresPesewas - finesPesewas - repairsPesewas - fuelPesewas;
}
